import React, { Fragment } from 'react';
import { translate } from 'react-i18nify';
import { SUPERSCRIPTED_GOAL_VALUES } from '../../../../constants';
import Tooltip from '../../../Journal/Tooltip';

const CustomGoalValue = (props) => {
  const isAccumboReference = props.original.severities.some((s) => s.severity === 'increased');

  let referenceValuesTitle;

  if (isAccumboReference) {
    referenceValuesTitle = props.original.severities
      .map(
        (s) =>
          `${translate(`decision_support_view.severities.${s.severity}`)}: ${s.lowerBound || ''}–${
            s.upperBound || ''
          }<br />`
      )
      .join('');
  } else {
    referenceValuesTitle = props.original.severities
      .filter((s) => s.severity === 'normal')
      .map(
        (s) => `${translate('decision_support_view.severities.normal')}: ${s.lowerBound || ''}–${s.upperBound || ''}`
      )
      .join('');
  }

  return (
    <Fragment>
      <Tooltip content={referenceValuesTitle}>
        <span className="icons info"></span>
      </Tooltip>
      {props.value ? (
        <Fragment>
          <span>{props.value}</span>
          {props.value && SUPERSCRIPTED_GOAL_VALUES.indexOf(props.original.code) > -1 ? <sup>1</sup> : null}
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default CustomGoalValue;
